module.exports = __webpack_public_path__ + "img/offer_icon.0d1888b4.svg";